import * as React from "react";
import { useGlobalSearchContext } from "../../../../../context/globalSearch.context";

export function ParentResourceItem({ data }) {
	const { isArabic } = useGlobalSearchContext();

	return (
		<div className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12 MuiGrid-grid-md-6">
			<div className="MuiGrid-root rectangleBox-25 MuiGrid-container">
				<div className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-3">
					<div className="imageContainer" style={{ position: "relative" }}>
						{/* Orange Background */}
						<svg
							className="orangeBg"
							// style={{ position: "absolute", left: 0, top: 0 }}
							preserveAspectRatio="none"
							width="132.875"
							// height="94.828"
							viewBox="0 0 361 248"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								fillRule="evenodd"
								clipRule="evenodd"
								d="M356.301 248C239.668 246.578 123.035 245.158 6.39956 243.737C13.0028 166.477 0 87.1253 0 0H353.457C368.571 78.7613 356.301 170.068 356.301 248Z"
								fill="#F5856D"
							/>
						</svg>

						<div
							className="imageCnt"
							dangerouslySetInnerHTML={{ __html: data.imageMarkup }}
						></div>
					</div>
				</div>
				<div className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-9">
					<p className="MuiTypography-root MuiTypography-body1">

					<a
						className="MuiTypography-root MuiLink-root MuiLink-underlineNone secondaryButton-52 parent-title"
						target="_self"
						href={data.link || "#"}
					>

						{data.title || "Default title"}
					</a>

					</p>
					{/* <p className="MuiTypography-root MuiTypography-body2">
						{data.author || "Default author"}
					</p> */}
					<a
						className="MuiTypography-root MuiLink-root MuiLink-underlineNone secondaryButton-52 MuiTypography-colorPrimary"
						target="_self"
						href={data.link || "#"}
					>
						<p className="MuiTypography-root MuiTypography-body2">
							{isArabic ? "المزيد" : "Read more"}
						</p>
						<svg
							className="r180deg"
							width="44"
							height="16"
							fill="#111111"
							viewBox="0 0 44 16"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								stroke="#111111"
								fill="#111111"
								d="M32.6878 16L31.3087 14.5428L32.0046 13.8844C34.2658 11.755 36.0985 10.1288 37.5356 8.98827L36.9872 8.95283C31.3943 8.60814 29.3931 8.43266 27.3906 8.41576C24.4479 8.39093 21.5024 8.70854 7.15242 9.33485L0.134119 9.64727L0.0446777 7.64102L11.1235 7.15492C23.7704 6.62619 26.1678 6.36863 28.5599 6.41013C30.2872 6.4401 32.0117 6.62598 37.5897 6.97826L37.9276 7.00035C34.5341 4.23789 32.8235 1.95848 32.8235 9.53674e-07H34.8278L34.8321 0.115196C34.9361 1.52154 36.9138 3.79001 40.8039 6.69435L41.47 7.18425L43.0447 8.32584L41.2033 8.94909L41.1236 8.97844C40.1024 9.3831 37.6425 11.3662 33.9341 14.8262L32.6878 16ZM38.9888 7.83767L39.037 7.87498L38.9838 7.91134L38.9888 7.83767Z"
							></path>
						</svg>
					</a>
				</div>
			</div>
		</div>
	);
}
